/**
 * @since 7.1.0
 */
export var RecurrenceFrequency;
(function (RecurrenceFrequency) {
    /**
     * @since 7.1.0
     */
    RecurrenceFrequency[RecurrenceFrequency["DAILY"] = 0] = "DAILY";
    /**
     * @since 7.1.0
     */
    RecurrenceFrequency[RecurrenceFrequency["WEEKLY"] = 1] = "WEEKLY";
    /**
     * @since 7.1.0
     */
    RecurrenceFrequency[RecurrenceFrequency["MONTHLY"] = 2] = "MONTHLY";
    /**
     * @since 7.1.0
     */
    RecurrenceFrequency[RecurrenceFrequency["YEARLY"] = 3] = "YEARLY";
})(RecurrenceFrequency || (RecurrenceFrequency = {}));
//# sourceMappingURL=recurrence-frequency.js.map